// extracted by mini-css-extract-plugin
export default {"hr":"Hr_hr__aWYkq","hrFullWidth":"Hr_hrFullWidth__I3klx"};